(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return policy; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    const cleanPath = path => path.replace(/\/+/g, '/');
    const cleanPaths = paths => {
      return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
    };
    const ROOT_PATH = window?.Shopify?.routes?.root || '/';
    cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
    cleanPaths({
      WISHLIST: `${ROOT_PATH}/pages/wishlist`,
      ACCOUNT: `${ROOT_PATH}/account`,
      LOGIN: `${ROOT_PATH}/account/login`,
      LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
    });
    window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const TIMEOUTS = {
      DELAY_50: 50,
      DELAY_150: 150,
      COMMON_DELAY_300: 300,
      DELAY_500: 500,
      DELAY_600: 600,
      DELAY_4000: 4000
    };

    const {
      getElementsByRef,
      getElementByRef
    } = window.PoleneLibs.Refs;
    const {
      isMobile,
      debounce,
      scrollBehavior
    } = window.PoleneLibs.Utils;
    async function initPolicyFeature() {
      const {
        policyTitle
      } = getElementsByRef('policy-title');
      const {
        policyMobileAccordionBtn
      } = getElementsByRef('policy-mobile-accordion-btn');
      if (!policyTitle || !policyMobileAccordionBtn) return;
      const policies = Array.isArray(policyTitle) ? policyTitle : [policyTitle];
      const accordionBtns = Array.isArray(policyMobileAccordionBtn) ? policyMobileAccordionBtn : [policyMobileAccordionBtn];
      const observerTeardown = setupSectionObserver(policies);
      const listenerTeardowns = policies.map(policy => {
        const handler = e => handlePolicyClick(e, policy);
        policy.addEventListener('click', handler);
        return () => policy.removeEventListener('click', handler);
      });
      const setEventListeners = () => {
        accordionBtns.forEach(btn => btn.addEventListener('click', updateAccordionHistory));
      };
      const removeEventListeners = () => {
        accordionBtns.forEach(btn => btn.removeEventListener('click', updateAccordionHistory));
      };
      const init = () => {
        setEventListeners();
        if (isMobile()) initMobileAnchor();
      };
      const updateAccordionHistory = event => {
        const targetBtn = event.currentTarget;
        const targetSection = targetBtn.parentNode;
        if (targetBtn.ariaExpanded === 'false') history.pushState(null, '', '#' + targetSection.id);
      };
      init();
      return function teardown() {
        listenerTeardowns.forEach(remove => remove());
        observerTeardown();
        removeEventListeners();
      };
    }
    function initMobileAnchor() {
      const sectionId = decodeURIComponent(window.location.hash.substring(1));
      const section = document.getElementById(sectionId);
      if (!section) return;
      const {
        policyMobileAccordionBtn,
        policySectionText,
        iconClose,
        iconOpen
      } = getElementByRef(['policy-mobile-accordion-btn', 'policy-section-text', 'icon-close', 'icon-open'], section);
      if (policyMobileAccordionBtn && policySectionText && iconClose && iconOpen) {
        const top = section.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        window.scrollTo({
          top,
          behavior: scrollBehavior()
        });
        policySectionText.focus({
          preventScroll: true
        });
        policyMobileAccordionBtn.ariaExpanded = 'true';
        policySectionText.classList.remove('hidden');
        iconOpen.classList.add('hidden');
        iconClose.classList.remove('hidden');
      }
    }
    function handlePolicyClick(e, policy) {
      e.preventDefault();
      const href = policy.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const targetId = href.slice(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const top = targetElement.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        window.scrollTo({
          top,
          behavior: scrollBehavior()
        });
        const {
          policySectionText
        } = getElementByRef('policy-section-text', targetElement);
        policySectionText?.focus({
          preventScroll: true
        });
        history.pushState(null, '', href);
        updateActiveMenuItem(href);
      }
    }
    function setupSectionObserver(menuItems) {
      const sections = menuItems.map(item => {
        const href = item.getAttribute('href');
        return href?.startsWith('#') ? document.getElementById(href.slice(1)) : null;
      }).filter(Boolean);
      let visibleSections = new Set();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const section = entry.target;
          if (entry.isIntersecting) {
            visibleSections.add(section);
          } else {
            visibleSections.delete(section);
          }
        });
        updateActiveSection(visibleSections);
      }, {
        threshold: [0],
        rootMargin: `-${getHeaderOffset()}px 0px -20% 0px`
      });
      sections.forEach(section => observer.observe(section));
      const debouncedScroll = debounce(() => updateActiveSection(visibleSections), TIMEOUTS.COMMON_DELAY_300);
      window.addEventListener('scroll', debouncedScroll, {
        passive: true
      });
      return function teardownObserver() {
        window.removeEventListener('scroll', debouncedScroll);
        observer.disconnect();
      };
    }
    function updateActiveSection(visibleSections) {
      if (visibleSections.size === 0) return;
      let bestSection;
      let bestPosition = Infinity;
      visibleSections.forEach(section => {
        const offset = Math.abs(section.getBoundingClientRect().top - getHeaderOffset());
        if (offset < bestPosition) {
          bestPosition = offset;
          bestSection = section;
        }
      });
      if (bestSection) {
        const href = `#${bestSection.id}`;
        updateActiveMenuItem(href);
      }
    }
    function updateActiveMenuItem(href) {
      const {
        policyTitle
      } = getElementsByRef(['policy-title']);
      if (!policyTitle) return;
      const menuItems = Array.isArray(policyTitle) ? policyTitle : [policyTitle];
      menuItems.forEach(item => item.classList.remove('active'));
      menuItems.forEach(item => {
        if (item.getAttribute('href') === href) {
          item.classList.add('active');
        }
      });
    }
    function getHeaderOffset() {
      const styles = getComputedStyle(document.body);
      return parseFloat(styles.getPropertyValue('--full-header-height').trim());
    }

    var policy = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: initPolicyFeature
    });

})();
